import type { SVGProps } from "react";
import { Handshake } from "lucide-react";

export function ADRIcon(props: SVGProps<SVGSVGElement>) {
  return <Handshake color="currentColor" {...props} className={`w-6 h-6 ${props.className ?? ""}`} />;
}
